import { action } from 'satcheljs/lib/legacy';
import {
    getGroupListNodesViewStateStore,
    GroupFolderNodeViewState,
} from 'owa-groups-shared-folders-store';

/*
 * Sets group folder node view state
 * @param groupId the smtp address of group
 * @param folderId the folder whose view state we are updating
 * @param groupFolderNodeViewState the view state to set
 */
export default action('setGroupFolderViewState')(function setGroupFolderViewState(
    groupId: string,
    folderId: string,
    groupFolderNodeViewState: GroupFolderNodeViewState
): void {
    getGroupListNodesViewStateStore()
        .groupListNodesViewStates.get(groupId.toLowerCase())
        ?.groupFolderNodeViewStates.set(folderId, groupFolderNodeViewState);
});
